export default class UserSession {
  static userId() {
    try {
      return window.currentUser.user_id;
    } catch(e) {
      return undefined;
    }
  }

  static isLoggedIn() {
    return UserSession.userId() !== undefined;
  }
}
